<mat-sidenav-container
  fullscreen
  class="sidebar"
>
  <mat-sidenav
    mode="side"
    [opened]="sidebarOpened()"
  >
    @if (sidebarOpened()) {
      <div>
        <div class="user-info">
          <div class="studio-name">
            @if (studioName(); as name) {
              {{ name }}
            }
          </div>
          <gymautow-user-info />
        </div>
        <hr />
        <div class="navigation">
          @for (link of links(); track link) {
            <a
              mat-button
              routerLinkActive="active"
              class="navigation__link"
              [routerLink]="link.route"
              (click)="onHandleLinkClick()"
            >
              {{ link.text }}
            </a>
          }
        </div>
      </div>
    }
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="page-content">
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>

<div class="toggle-sidenav-button">
  <button
    mat-mini-fab
    color="primary"
    (click)="sidebarOpened.set(!sidebarOpened())"
  >
    <mat-icon>menu</mat-icon>
  </button>
</div>
